export default __webpack_public_path__ + "static/media/TS_Backlog_-_iljujjkin_-_1463548_-_Bombardier_Challenger_350 2.b446b1e2.png";